<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <div class="nav">
      <exception-dropdown
        v-if="
          $can('GetErrorNotification', 'Report') ||
          $can('GetFailedRefundRequests', 'Report') ||
          $can('GetNotificationAlertToTrackingPayment', 'Report') ||
          $can('GetWeeklyMismatchSummaryAlert', 'Report') ||
          $can('GetStatementAvailablityAlert', 'Report')
        "
      />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <dark-Toggler class="d-none d-lg-block" />
      <Merchant-dropdown :userCompanies="userCompanies" />
      <user-dropdown :userData="userData" />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav, BButton, BTooltip } from "bootstrap-vue";
import DarkToggler from "./components/DarkToggler.vue";
import UserDropdown from "./components/UserDropdown.vue";
// eslint-disable-next-line import/extensions
import MerchantDropdown from "./components/NotificationDropdown";
import ExceptionDropdown from "./components/ExceptionDropDown.vue";
import axios from "@axios";
import store from "@/store/index";

export default {
  components: {
    BLink,
    BButton,
    BTooltip,
    // Navbar Components
    BNavbarNav,
    DarkToggler,
    UserDropdown,
    MerchantDropdown,
    ExceptionDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("permission/fetchUserData");
  },
  computed: {
    userData() {
      return this.$store.state.permission.userData?.user || {};
    },
    userCompanies() {
      return this.$store.state.permission.userData?.companies || [];
    },
  },

  methods: {},
};
</script>

<style scoped>
.bbutton {
  animation: bbutton-animation 1.5s ease infinite;
}

@keyframes bbutton-animation {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
